import { useCallback, useEffect } from 'react'

import { ListingSectionObject } from '../transports/common/listing-section-transport'
import { useInView } from 'react-intersection-observer'
import { trackListings, getTrackingArray } from './utils'

const _trackingIntersectionObserverOptions = {
    root: null,
    threshold: 0.99,
    triggerOnce: true,
}

export const usePropertyCardTracking = (
    propertyObject: ListingSectionObject,
    listingType?: string | null,
    index?: number,
) => {
    const [intersectionTargetRef, inView] = useInView(_trackingIntersectionObserverOptions)
    useEffect(() => {
        if (inView) {
            trackListings(getTrackingArray(true, propertyObject, listingType, index))
        }
    })

    const propertyCardClickTracking = useCallback(
        (propertyObject: ListingSectionObject, listingType?: string | null) => {
            trackListings(getTrackingArray(false, propertyObject, listingType))
        },
        [],
    )

    return { intersectionTargetRef, propertyCardClickTracking }
}
